import Link from 'next/link'
import { btn, cx } from '@/lib/ui'
import { errorMessage } from '@/lib/client-api'

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex flex-1 items-center justify-center p-10 text-sm text-muted" role="status">
      {label}
    </div>
  )
}

export function LoadFailed({ error, retry }: { error: unknown; retry?: () => void }) {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col justify-center px-5 py-16">
      <p className="font-mono text-[11px] uppercase tracking-[0.1em] text-muted">Could not load</p>
      <h1 className="mt-2 text-xl font-semibold tracking-tight">{errorMessage(error)}</h1>
      <div className="mt-6 flex gap-2">
        {retry && (
          <button type="button" onClick={retry} className={cx(btn.base, btn.primary)}>
            Try again
          </button>
        )}
        <Link href="/" className={cx(btn.base, btn.secondary)}>
          Home
        </Link>
      </div>
    </div>
  )
}

/** A page that is not there, in ROUTR's own clothes rather than the framework's. */
export function NotFound() {
  return (
    <main className="mx-auto flex w-full max-w-lg flex-1 flex-col justify-center px-5 py-16">
      <p className="font-mono text-[11px] uppercase tracking-[0.1em] text-muted">Error 404</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight">There is nothing here</h1>
      <p className="mt-2 text-sm text-muted">The page you asked for does not exist, or it belongs to a workspace you are not a member of.</p>
      <div className="mt-6">
        <Link href="/" className={cx(btn.base, btn.primary)}>
          Back to your projects
        </Link>
      </div>
    </main>
  )
}
